import { useMemo } from 'react';
import { isEmptyArray } from '../../../core/util/array';
import { EMPTY_STRING } from '../../../core/util/string';
import { safeGet } from '../../../core/util/object';
import useSelectFetchAccountAppointments from './useSelectFetchAccountAppointments';

export default (userProfileId: any) => {
  const { pastAppointments, upcomingAppointments } = useSelectFetchAccountAppointments(
    userProfileId
  );

  return useMemo(() => {
    let locationId = null;
    if (isEmptyArray(pastAppointments) && isEmptyArray(upcomingAppointments))
      locationId = EMPTY_STRING;
    else if (!isEmptyArray(pastAppointments) && isEmptyArray(upcomingAppointments)) {
      locationId = safeGet(pastAppointments[pastAppointments.length - 1])('location_id');
    } else if (
      !isEmptyArray(upcomingAppointments) ||
      (!isEmptyArray(pastAppointments) && !isEmptyArray(upcomingAppointments))
    ) {
      locationId = safeGet(upcomingAppointments[upcomingAppointments.length - 1])('location_id');
    }
    return locationId;
  }, [pastAppointments, upcomingAppointments]);
};
